<template>
    <div>
        <template v-if="onboarding_documents === true">
            <div class="page-top mb-1 mb-3 clearfix">
                <h1 class="float-left"> Onboarding Documents </h1>
                <router-link to="/addOnboardingDocuments" class="btn btn-primary active float-right"> Add Onboarding Documents</router-link>
              <div class="searching float-right mr-2">
                <input id="customSearch" type="text" class="form-control search" companyName="" />
              </div>
            </div>
            <table id="onboarding_documnents_table" class="table" width="100%">
                <thead>
                    <tr>
                        <th>id</th>
                        <th>Sr No.</th>
                        <th>Document Title</th>
                        <th>Description</th>
                        <th>Account Type</th>
                        <th>Has Sample</th>
                        <th>Active</th>
                        <th>Required</th>
                        <th>Multiple</th>
                        <th>Created By</th>
                        <th>Updated By</th>
                        <th class="text-center">Action</th>
                    </tr>
                </thead>
            </table>
        </template>
        <template v-else-if="onboarding_documents === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="onboarding_documents === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                data : null,
                pageView: null,
                onboarding_documents: null
            };
        },
        methods: {
            callDataTable(){
                var that = this;
                var onboarding_documnents_table = $('#onboarding_documnents_table').DataTable({
                    "sDom": '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                    processing: true,
                    serverSide: true,
                    searching: true,
                    ajax: {
                        "url": "api/onboardingDocumentsList",
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": "records",
                    },
                    deferRender: true,
                    columns: [
                        {data: 'id'},
                        {render: function(data,type,full,row){
                            var rowNo = row.row+1+(row.settings.oAjaxData.start);
                            return rowNo;
                        }},
                        {data: 'doc_title'},
                        {data: 'description'},
                        {data: 'account_type.type'},
                        {data: 'has_sample'},
                        {data: 'is_active'},
                        {data: 'is_required'},
                        {data: 'is_multiple'},
                        {data: 'creator.name'},
                        {render: function(data,type,full,row){
                            if(full.updator != null) {
                                return full.updator.name;
                            } else {
                                return 'Not updated yet!';
                            }
                            
                            return data;
                        }},
                        {data: 'id', sorting: false, render: function(data,type,full){
                            var $url = '/editOnboardingDocuments/'+full['id'];
                            return '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" class="action edit" ><i class="fas fa-pencil-alt"></i></a>';
                        }}
                    ],
                    "order": [[ 0, "asc" ]],
                    "columnDefs": [
                        {
                            "targets": [ 0 ],
                            "visible": false,
                            "searchable": false
                        },{
                            "targets": 3,
                            "render": function ( data, type, row ) {
                                    return "<textarea class='lg-textarea form-control' rows='4' name='diagnosis' id='diagnosis' readonly>"+data+"</textarea>";
                                }  
                        }],
                    "initComplete": () => {
                        this.$Progress.finish();
                    }
                });
              $('#customSearch').on( 'keyup', function (e) {
                if (e.keyCode === 13) {
                  onboarding_documnents_table.search(this.value).draw();
                }
              });
            }
        },
        mounted() { 
            this.$Progress.start();
			this.can('onboarding_documents').then(result => {
                if(result.onboarding_documents == true)
                {
                    this.onboarding_documents = true;
                } else {
                    this.onboarding_documents = false;
                }
            }).then(result => {
                if(this.onboarding_documents == true){
					this.callDataTable();
                    this.$Progress.finish();
                }else{
                    this.$Progress.finish();
                }
            });

        },
    }
</script>
